import React from 'react';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import { LuWatch } from 'react-icons/lu';
import { IoThumbsUpSharp } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';

export default function Subscription() {
	return (
		<main className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<div className="block w-100 flex-row mt-5 pb-20">
				<div className="flex mt-30 space-x-80">
					<h1 className="text-3xl font-bold text-gray-700 w-5/12">
						Subscription
					</h1>
					<div className=" flex"></div>
				</div>

				<div className="border-t border-gray-300 my-10 w-full"></div>

				<div className="w-full sm:w-7/12">
					<div className=" flex pt-5 px-4 border-l-2 border-green-500 bg-green-50 bg-opacity-60">
						<div className="mt-1">
							<IoThumbsUpSharp size="20" className="text-yellow-400" />
						</div>
						<div className="block pl-3">
							<p className="text-base font-semibold text-green-600 sm:text-xl">
								In a nutshell
							</p>
							<p className="text-xs sm:text-sm mt-3 text-gray-700">
								A created subscription link has recurring functionality built
								into it. The link will allow you to collect payment on a chosen
								interval and set limit, without having to manage how your
								customer is billed throughout the cycle.
							</p>
						</div>
					</div>
				</div>

				<div className="block mt-4">
					<p className="text-sm text-gray-700 w-full sm:w-8/12">
						To create a subscription link that your customers can use to
						subscribe, you have to do the following:
					</p>
					<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12 pl-3">
						1. Create a plan
					</p>
					<p className="text-sm mt-2 text-gray-700 w-full sm:w-8/12 pl-3">
						2. Create a subscription link.
					</p>
				</div>

				<div
					id="createplan"
					className="block w-full sm:w-10/12 pt-4 items-center"
				>
					<p className="text-xl text-gray-700 font-semibold w-full sm:w-8/12">
						Create a plan
					</p>
					<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
						Plan is the starting point for creating a subscription. This is what
						tells our system how much you are billing the customer, how often
						you want the billing to be, the duration to bill the customer and
						when the billing should commence.
					</p>
					<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
						To create a plan, visit spay plan route and follow the steps below:
					</p>

					<div className="flex pl-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							When you visit the plan route on the spay dashboard, you will see
							plans that you have created. If you have not created a plan, you
							will see an empty page
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig1.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 1.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							When you have click on add plan button, you will see a form to
							fill. Plan Name, Amount, Set Limit, Interval and Description are
							required.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig2.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 1.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							When you have filled the form completely and you click on create,
							you will be redirected to see what you have created. This shows
							the details of what you have created and if you are not satisfied
							or you made a mistake, you can make correction by clicking on edit
							plan.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig3.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 1.
						</p>
					</div>
				</div>

				<div
					id="subscriptionlink"
					className="block w-full sm:w-10/12 pt-4 items-center"
				>
					<p className="text-xl text-gray-700 font-semibold w-full sm:w-8/12">
						Create a subscription link
					</p>
					<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
						There are two ways to create a subscription link: You can either
						create them from an existing plan or create them while creating a
						new plan.
					</p>
					<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
						To create a link that a user can use to subscribe, visit spay
						payment link route and follow the steps below:
					</p>

					<div className="flex pl-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							When you have clicked on the payment-link route, you will see
							payment-links you have created or an empty page if you have not.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig4.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 4.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							To create a subscription link, click on the add payment link
							button. You will be shown with two options to select from. Click
							on the subscription option.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig5.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 5.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							When you click on subscription option, you will be shown three
							options: create a new plan, use an existing plan or cancel.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig6.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 6.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							Once you select{' '}
							<span className="font-bold">one of my existing plans,</span> you
							will be shown a form to fill. You will select from the plans you
							have created and give the link a name, which are required to
							create a subscription link. You can also fill in additional fields
							based on what you want. You can view them by clicking on show
							more.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig7.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 7.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							When you fill in the form and click on create, you will be
							redirected to see what you have created. This page usually
							contains the link that you can copy and send to your customer to
							subscribe. You can edit, delete or un-publish this link.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig8.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 8.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							Likewise, you can create a subscription link from I want to create
							a new plan option in Fig 5. The below form, Fig 8, will be
							displayed and once completely filled, you will be redirected to
							the Fig 7.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig9.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 9.
						</p>
					</div>

					<div className="flex pl-2 mt-2 items-center space-x-2">
						<div className="w-1 h-1 bg-black rounded-full"></div>
						<p className="text-sm mt-3 text-gray-700 w-full sm:w-8/12">
							Once the link is clicked, your customers will be asked to fill in
							the page in Fig 9 below and once they have successfully made
							payment, you will receive a mail and their details will also
							reflect on your dashboard.
						</p>
					</div>

					<div className="mt-4 block w-full sm:w-8/12">
						<img
							src={require('../../assets/sub-fig0.png')}
							alt="overview"
							className="object-cover border border-gray-300"
							width={800}
							height={500}
						/>
						<p className="text-sm mt-2 text-gray-700 italic text-center">
							Fig 10.
						</p>
					</div>
				</div>

				<div className="border-t border-gray-300 w-full my-10"></div>

				<div className="flex pb-12 w-full sm:w-7/12 justify-between">
					<NavLink to="/test-payment">
						<div className="flex">
							<div className="sm:mt-1 mt-2">
								<MdArrowBack size={16} color="gray" />
							</div>
							<p className="sm:text-base ml-2 sm:mt-0 mt-2 sm:font-medium text-xs text-gray-600">
								Test Payment
							</p>
						</div>
					</NavLink>
					<NavLink to="/virtual-account">
						<div className="flex content-end">
							<p className="sm:text-base sm:mt-0 mt-2 text-xs mr-2 sm:font-medium text-gray-600">
								Virtual Account
							</p>
							<div className="sm:mt-1 mt-2">
								<MdArrowForward size={16} color="gray" />
							</div>
						</div>
					</NavLink>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<div className="mb-2">
							<h3>Table of Contents</h3>
						</div>
						<div className="">
							<a href="#createplan">
								<p className="text-sm">Create a plan</p>
							</a>
							<a href="#subscriptionlink">
								<p className="text-sm">Create a subscription link.</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}
